<template>
    
    <b-row>
        <b-col md="4" cols="12">
            <ShowSessionMinutesFile :data='data.meeting_minute_id' message="التي تم خلالها الموافقة على الموافقة على الدمج" />
        </b-col>
        <b-col md="4" cols="12">
            <info-card
            label="المنظمة المندمجة"
                :value="data.merged_ngo_id ? data.merged_ngo_id.name_ar:''"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card label="رقم قرار الهيئة العامة/ مجلس الأمناء للمنظمة المندمجة المتضمن الموافقة على الدمج"
                :value="data.merger_resolution_number"
            />
        </b-col>
    </b-row>
  </template>
  
  <script>
  import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton } from "bootstrap-vue";
  import InfoCard from "@/components/InfoCard.vue";
  import ShowSessionMinutesFile from './ShowSessionMinutesFile.vue'
  export default {   
    data() {
        return {
            file: '',
        }
    },
    components: {
        BCard, BImg , BCol , InfoCard , BRow , BButton, ShowSessionMinutesFile
    },
    props: {
        data : Object ,
    },
    
    directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
    },
  };
  </script>